import "../index.css";
import { AppLandingPage } from "./app-landing-page.tsx";
import { reactHydrate } from "../react-hydrate.ts";

window.Components = {
  AppLandingPage: AppLandingPage,
};

reactHydrate();
